import {useEffect, useRef} from 'react';

export function useOnce(effect: () => void, deps: any[] = []) {
    const hasRun = useRef(false);

    useEffect(() => {
        if (!hasRun.current) {
            effect();
            hasRun.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return hasRun; // <- return the ref so it's trackable
}
